import "core-js/modules/es6.regexp.to-string";
/*
 * @Author: 张宇 1204569549@qq.com
 * @Date: 2021-09-24 09:37:43
 * @LastEditors: 张宇 1204569549@qq.com
 * @LastEditTime: 2022-08-06 11:12:06
 * @FilePath: \screening-sys\src\utils\validate.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by jiachenpan on 16/11/18.
 */

import { Message } from "element-ui";
import { toStorage } from "./index";
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
export function validUsername(str) {
  var valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
export function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}
export function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
export function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
export function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
export function validEmail(email) {
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }
  return Array.isArray(arg);
}
/**
 * 图片上传
 * @param {file} file el-upload文件对象
 * @param {number} size 限制的文件大小(kb) 默认10M
 */
export var validImgUpload = function validImgUpload(file, size) {
  size = +size || 10240;
  var isSizeOut = file.size / 1024 > size;
  // if (isSizeOut) {
  //   Message.error("上传图片大小不能超过" + toStorage(size * 1024))
  // }
  return !isSizeOut;
};